import { useState } from 'react';

import useSocket from './useSocket';

/**
 * Custom Hook that combines state with the emitting event from the socket instance
 * @param event the event you want to emit when you set the state
 * @param initialState initial state
 * @returns `[state, setState, setStateEmit]`
 * state is the state. setState sets the state. setStateEmit sets the state and emits the `event` parameter. You can emit extra arguments too
 */
const useStateEmit = <S>(event: string, initialState: S | (() => S)): [S, React.Dispatch<React.SetStateAction<S>>, React.Dispatch<React.SetStateAction<S>>] => {
	const [state, setState] = useState<S>(initialState);
	const socket = useSocket();

	const setStateEmit = (nextState: React.SetStateAction<S>, ...args: any[]) => {
		setState(prevState => {
			const newState = nextState instanceof Function ? nextState(prevState) : nextState;
			socket.emit(event, newState, ...args);
			return newState;
		});
	};

	return [state, setState, setStateEmit];
};

export default useStateEmit;